import { render, staticRenderFns } from "./DginIndex.vue?vue&type=template&id=fa8acd42&scoped=true"
import script from "./DginIndex.vue?vue&type=script&lang=js"
export * from "./DginIndex.vue?vue&type=script&lang=js"
import style0 from "./DginIndex.vue?vue&type=style&index=0&id=fa8acd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8acd42",
  null
  
)

export default component.exports